import { useMutation } from 'react-relay';

import { checkBankAccountMutation } from '@/__generated__/checkBankAccountMutation.graphql';
import { checkBankAccount } from '@/graphql/mutation/taxRefund/checkBankAccount';

export const useCheckBankAccount = () => {
  const [commit, isInFlight] = useMutation<checkBankAccountMutation>(checkBankAccount);

  return { commit, isInFlight };
};
